import { memo, VFC, useState, useEffect } from "react";
import {
  Heading,Box,Flex,Spacer,Divider,
  Text,Center,Spinner,
  Tabs,TabList,TabPanels,Tab,TabPanel,
} from "@chakra-ui/react";
import { IssueDetail } from '../../molecules/IssueDetail';
import { IssueHistory } from '../../molecules/IssueHistory';
import { CustomerTable } from '../../molecules/CustomerTable';
import { issueDetailObj } from '../../../types/issue';
// import { useLoginUser } from "../../../hooks/providers/useLoginUserProvider";

type Props = {
  issueArn: string;
  executing: boolean;
  issueDetailObj: issueDetailObj|null;
};

export const IssueDetailBase: VFC<Props> = memo((props) => {
  const { issueArn, executing, issueDetailObj } = props;
  // const { loginUser } = useLoginUser();
  const [ dataTime, setDataTime ] = useState("");

  useEffect(() => {
    if( issueDetailObj ){
      setDataTime("（" + issueDetailObj.get_data_time + "現在）"?? "");
    }
  }, [issueDetailObj]);
  
  return (
    <Center> 
      <Box
        w="95%"
        bg="white"
        borderRadius="10px"
        shadow="md"
        margin="10px"
      >
        <Flex m="10px">
          <Heading size="md" margin="5px">
            <Flex>■個別障害情報<Text color="green">{dataTime} </Text></Flex>
          </Heading> 
          <Spacer />
        </Flex>
        
        {(executing || !issueDetailObj) ? (
          <Center h="80vh">
            <Spinner color="teal.500" />
          </Center>
        ) : (
          <>
          <Divider orientation="horizontal" mt="10px" />
          <IssueDetail issueDetailObj={issueDetailObj} />
          
          <Box mt="20px" padding="10px">
            <Tabs align="center" variant="enclosed-colored">
              <TabList id="mypagetabs">
                <Tab>障害詳細</Tab>
                <Tab>影響アカウント一覧</Tab>
              </TabList>
                
              <TabPanels>
              
                <TabPanel>
                  <IssueHistory issueArn={issueArn} issueDetailObj={issueDetailObj} />
                </TabPanel>
                
                <TabPanel>
                  <CustomerTable
                    executing={executing}
                    custList1={issueDetailObj.customer_list1}
                    custList2={issueDetailObj.customer_list2}
                    custList3={issueDetailObj.customer_list3}
                    mode='' />
                </TabPanel>
              
              </TabPanels>
            </Tabs>
          </Box>
          </>
        )}
      </Box>
    </Center>
  );
});
